export const baseUrl = "https://api.nedaposhtam.com";
// export const baseUrl = "http://192.168.10.112:8002";
